import * as React from "react";
import { useRouter } from "next/router";
import { verifyEmail } from "@nju/data-access-portal-user";
import { Icon } from "@nju/icons";
import { isOk } from "@nju/result";
import { portalRoutes } from "@nju/routes";
import { BlockText, Button, Text } from "@nju/ui";

export function VerifyEmail() {
  const router = useRouter();

  const onVerifyEmail = React.useCallback(async () => {
    const result = await verifyEmail();

    if (isOk(result)) {
      router.push(
        portalRoutes.mojeKonto.mojProfil.zmienAdresEmail.wiadomoscWyslana.get(),
      );
    } else {
      router.push(portalRoutes.mojeKonto.mojProfil.zmienAdresEmail.blad.get());
    }
  }, [router]);

  return (
    <>
      <div className="flex">
        <Icon className="mt-[2px]" name="info-circle" tone="accent" />
        <div className="px-3">
          <BlockText
            size={{
              "@onlyMobile": "s",
              "@fromTablet": "m",
            }}
          >
            e-mail nie dotarł?
          </BlockText>
          <Button
            display="inline"
            onPress={onVerifyEmail}
            size="inline"
            variant="simple"
          >
            <Text
              size={{
                "@onlyMobile": "s",
                "@fromTablet": "m",
              }}
              tone="accent"
              weight="bold"
              withUnderline={true}
            >
              wyślij ponownie
            </Text>
          </Button>
        </div>
      </div>
    </>
  );
}
